var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 960) scale(1, -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M693.252 286.253c0-10.772-8.733-19.505-19.505-19.505h-303.989v-189.339h512.833v512.833h-189.339v-303.989zM902.095 629.252c10.772 0 19.505-8.733 19.505-19.505v-551.842c0-10.772-8.733-19.505-19.505-19.505h-551.842c-10.772 0-19.505 8.733-19.505 19.505v208.844h-208.844c-10.772 0-19.505 8.733-19.505 19.505v551.842c0 10.772 8.733 19.505 19.505 19.505h551.842c10.772 0 19.505-8.733 19.505-19.505v-208.844h208.844zM654.242 305.758v512.833h-512.833v-512.833h512.833z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.74c117252a41b987078397baed72eb48.svg";
export { ForwardRef as ReactComponent };